import { createSlice } from '@reduxjs/toolkit';

import { EMPTY_VALUES } from 'constants/general';

const initialState = {
	superiorUsers: EMPTY_VALUES.ARRAY,
	subordinateUsers: EMPTY_VALUES.ARRAY,
	userDataFromDB: false,
};

export const resolverSettings = createSlice({
	name: 'resolverSettings',
	initialState,
	reducers: {
		saveSuperiors: (state, { payload }) => ({
			...state,
			superiorUsers: payload,
		}),
		saveSubordinates: (state, { payload }) => ({
			...state,
			subordinateUsers: payload,
		}),
		setUserDataDBFlag: (state, { payload }) => ({
			...state,
			userDataFromDB: payload,
		}),
		reset: () => initialState,
	},
});

export default resolverSettings.reducer;
export const REDUCER_NAME = resolverSettings.name;

export const { saveSuperiors, saveSubordinates, setUserDataDBFlag, reset } = resolverSettings.actions;
